/* eslint-disable max-len */
import 'react';

function Close(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="12px"
            height="12px"
            viewBox="0 0 12 12"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g id="分享&amp;权限" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="页面分享04"
                    transform="translate(-1663.000000, -152.000000)"
                    fill="#4E4F52"
                    fillRule="nonzero"
                >
                    <g id="编组-23备份-5" transform="translate(1335.000000, 142.000000)">
                        <g id="关闭备份-7" transform="translate(328.000000, 10.000000)">
                            <path
                                d="M11.2873652,0 L12,0.604545503 L6.655,6 L12,11.3954545 L11.2873652,12 L6,6.662 L0.712634824,12 L0,11.3954545 L5.344,6 L0,0.604545503 L0.712634824,0 L6,5.338 L11.2873652,0 Z"
                                id="Combined-Shape"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default Close;
